module.exports = __webpack_public_path__ + "img/ryanne.37180f87.png";